import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    userInfo: {},
    isLogin: false,
    publicOpenid:"",
    unionid:""
  },
  mutations: {
    getUserInfo (state, name) {
      state.userInfo = name
    },
    GetLogin  (state, name) {
      state.isLogin = name
      console.log(name);
    },
    getPublicOpenid(state,item){
      state.publicOpenid=item
    },
    getUnionid(state,item){
      state.unionid=item
    }
  },
  actions: {

  },
  modules: {

  },
})



// WEBPACK FOOTER //
// ./src/store/index.js